import { GoabIcon, GoabLink, GoabSideMenu } from '@abgov/angular-components';
import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

export interface HelpMenuItem {
  id: string;
  label: string;
}

@Component({
  selector: 'app-help-page',
  imports: [
    GoabSideMenu,
    GoabLink,
    GoabIcon,
    RouterLink,
    RouterLinkActive,
    RouterOutlet,
  ],
  templateUrl: './help-page.html',
  styleUrl: './help-page.scss',
})
export class HelpPage {
  readonly menuItems: HelpMenuItem[] = [
    { id: 'help-and-support', label: 'Help and Support' },
    {
      id: 'getting-numbers-right',
      label: 'Getting the numbers right: how to fill out the form',
    },
    { id: 'account-changes', label: 'Account changes' },
    { id: 'smoking-policy', label: 'Smoking policy' },
    { id: 'frequently-asked-questions', label: 'Frequently asked questions' },
    { id: 'email-support', label: 'Email the support team' },
  ];
}
